import React, { useState, useEffect } from 'react';
import styled from 'styled-components'
import { Flex, Box } from 'ui/acro'
import { LightTheme } from 'ui/bend'
import { ThemeProvider } from 'styled-components'
import { ClassCard } from 'components_v1/SchemaSectionRenderer/common/components'
import { axios } from '../api'

const ClassCardsContainer = styled(Flex)`
  align-items: center;
  flex-wrap: wrap;
  text-align: left;
`
const Title = styled(Flex)`
  color: ${(props) => props.theme.colors.black};
  text-align: center;
  justify-content: center;
  font-family: ${(props) => props.theme.fonts.Proxima};
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  line-height: 40px; /* 125% */
  letter-spacing: -0.96px;
  text-transform: uppercase;
  margin-bottom: 32px;
`

const WorkoutsSection = ({planDetails, planEntries}) => {
  const [classes, setClasses] = useState();
  const { id, slug } = planDetails;
  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const res = await axios.get(`/plan_entries?plan_id=${slug}`)
      if (res.status === 200) {
        setClasses(res?.data)
      }
    } catch (e) {
      console.error(e)
    }
  }

  return (
    <ThemeProvider theme={LightTheme}>
      <Title>Classes </Title>
      {classes &&
        <ClassCardsContainer
          gap={['4%','2%']}
          pl={['0px', '16px', '105px']}
          pr={['0px', '16px','105px']}
        >
        {classes.map((classItem, index) => (
          <Box
            width={['48%', '32%', '32%', '32%']}
            mb='16px'
            style={{alignSelf: "stretch"}}
          >
            <ClassCard {...classItem} showAllMetaData={false} cardIndex={index + 1} />
          </Box>
        ))}
      </ClassCardsContainer>
      }
    </ThemeProvider> 
  );
};

export default WorkoutsSection;
